<template>

</template>

<script>
export default {
    name: "design-2021-apprentice-google-map-marker-component",
    props: {
        title: {
            type: String,
            required: true,
        },

        google: {
            type: Object,
            required: true,
        },

        googleMapApi: {
            type: String,
            required: true,
        },

        map: {
            type: Object,
            required: true,
        },

        address: {
            type: Object,
            required: true,
        },
    },

    mounted() {
        if (this.title === '' || this.address.street === '' || this.address.number === '' || this.address.zipcode === '' || this.address.location === '') {
            return
        }

        this.marker = new this.google.maps.Marker({
            position: this.map.center,
            map: this.map,
            title: this.title,
        });

        const infowindow = new this.google.maps.InfoWindow({
            content: this.getAddress(),
            ariaLabel: this.title,
        });

        this.marker.addListener("click", () => {
            infowindow.open({
                anchor: this.marker,
                map: this.map,
            });
        });
    },

    methods: {
        getAddress() {
            return `<div class="marker-address">
                <div class="name">${this.title}</div>
                <address>
                    ${this.address.street} ${this.address.number},<br>
                    ${this.address.zipcode} ${this.address.location}
                </address>
            </div>`
        },
    }
}
</script>

<style scoped lang="scss">

</style>
